// external imports
import { vsprintf } from 'sprintf-js';
import { v4 as generateUuid } from "uuid";
import { iDef } from './TypeUtils';

// internal imports
// none

/**
 * @overview: Collection of utilities for operating on or producing strings.
 * Similar to the StringUtil in wicket14.
 */

export default class StringUtil {
	public static EMPTY: string = "";
	public static SPACE: string = " ";

	public static insertAt(target: string, insert: string, position: number) {
		return [target.slice(0, position), insert, target.slice(position)].join('');
	}

	public static includesIgnoreCase(str: string, value: string): boolean {
		return (str || '').toLowerCase().indexOf((value || '').toLowerCase()) > -1;
	}

	public static format(message: string, ...args: string[] | number[]): string {
		return vsprintf(message, args);
	}

	public static formatTemplate(message: string, args: { [key: string]: string | number | undefined | null}) {
		if (!args || Object.keys(args).length < 1) {
			return message;
		}

		const rx = new RegExp("\\$\\{(" + Object.keys(args).join('|') + ")\\}");

		return message.replace(rx, (match): string => {
			return (args[message.slice(2, match.length - 1)]).toString() || "";
		});
	}

	public static sanitize(str: string) {
		return str.replace(/[^A-z0-9]+/, "_");
	}

	public static isEmpty(str?: string) {
		return !str || str.length < 1;
	}

	public static toInteger(str: string, defaultIfNaN?: number): number {
		let n = defaultIfNaN;
		const i = parseInt(str, 10);
		if (!isNaN(i)) {
			n = i;
		}
		return n;
	}

	public static toIntegerList(str: string): number[] {
		if (!str) {
			return [];
		}

		const lst = [];

		for (const sub of str.split(',')) {
			iDef(this.toInteger(sub), (n) => lst.push(n));
		}

		return lst;
	}

	public static toFloat(str: string, defaultIfNaN?: number): number {
		let n = defaultIfNaN;
		const i = parseFloat(str);
		if (!isNaN(i)) {
			n = i;
		}
		return n;
	}

	public static toBoolean(str: string, defaultValue: boolean = false): boolean {
		if (!str) {
			return defaultValue;
		}

		return str.toLowerCase() === 'true';
	}

	public static generateUuid(): string {
		return generateUuid();
	}

	public static replaceAll(target, search, replacement) {
		return target.replace(new RegExp(search, 'g'), replacement);
	}
}

// also provide each of the functions as individual exports
export const insertAt = StringUtil.insertAt;
export const includesIgnoreCase = StringUtil.includesIgnoreCase;
export const format = StringUtil.format;
export const sanitize = StringUtil.sanitize;
export const toInteger = StringUtil.toInteger;
export const toFloat = StringUtil.toFloat;



// WEBPACK FOOTER //
// ./src/core/util/StringUtil.ts